import { render, staticRenderFns } from "./stockLocations.vue?vue&type=template&id=3274e273&scoped=true"
import script from "./stockLocations.vue?vue&type=script&lang=js"
export * from "./stockLocations.vue?vue&type=script&lang=js"
import style0 from "./stockLocations.vue?vue&type=style&index=0&id=3274e273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274e273",
  null
  
)

export default component.exports